import getClient from "./getClient";

export default function signIn({ email }) {
  return getClient().auth.signInWithOtp({ email });
}
